module.exports = __webpack_public_path__ + "img/for-men-3.0d8b5f7.webp";